import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import type { ICategory, ICategoryListParams } from "./types";

/**
 * 카테고리 목록을 조회하는 API 함수
 * @param params 쿼리 파라미터 (필터링, 페이징)
 * @returns API 응답 객체
 */
export const apiGetCategories = async (params?: ICategoryListParams) => {
  const response = await apiGet<ICategory[]>("/categories", params);
  return response.data;
};

/**
 * 카테고리 목록을 React Query를 통해 조회하는 훅
 * @param params 쿼리 파라미터 (필터링, 페이징)
 * @param options React Query 옵션
 * @returns 쿼리 결과
 */
export const useQueryGetCategories = (
  params?: ICategoryListParams,
  options = {}
) => {
  const queryKey = ["categories", params];

  return useQuery({
    queryKey,
    queryFn: async () => {
      return await apiGetCategories(params);
    },
    ...options,
  });
};

export default useQueryGetCategories;
